import { render, staticRenderFns } from "./detailMobil.vue?vue&type=template&id=14e08053&"
import script from "./detailMobil.vue?vue&type=script&lang=ts&"
export * from "./detailMobil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports